var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"footer__copy"},[_vm._v(_vm._s(_vm.$l10n("COPYRIGHT")))]),_c('div',{staticClass:"footer__links"},[_c('Links',{attrs:{"links":_vm.links,"social":_vm.social}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }